<div class="flex flex-row flex-wrap gap-1">
  @for (tag of tags(); track tag) {
    <div class="badge badge-primary">
      <smallstack-i18n [data]="tag"></smallstack-i18n>
    </div>
  }
</div>
